/*globals VXConfig*/
function getPromotionBadge() {
	return VXConfig.happyHourPromotionBadge;
}

export {getPromotionBadge};